"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFExporter = void 0;
const jspdf_1 = __importDefault(require("jspdf"));
const html2canvas_1 = __importDefault(require("html2canvas"));
class PDFExporter {
    constructor(containerSelector = '.app-content') {
        const container = document.querySelector(PDFExporter.DEFAULT_SELECTOR);
        if (!container) {
            throw new Error('Container not found!');
        }
        this.container = container;
        this.capturedPages = [];
        this.pdf = new jspdf_1.default({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });
    }
    static generateFileName() {
        const defaultFileName = `Chord_Sheet_${new Date().toISOString().slice(0, 10)}.pdf`;
        const userInput = prompt('Enter File Name', defaultFileName);
        if (userInput === null) {
            return false;
        }
        return userInput.trim() || defaultFileName;
    }
    static setFixedSize(container, width, height) {
        container.style.width = `${width}px`;
        container.style.height = `${height}px`;
        container.style.boxSizing = 'border-box';
    }
    static resetOriginalSize(container) {
        container.style.width = '';
        container.style.height = '';
        container.style.overflow = '';
    }
    static moveToFirstPage() {
        return __awaiter(this, void 0, void 0, function* () {
            const prevButton = document.querySelector('.prev-button');
            while (prevButton && window.getComputedStyle(prevButton).pointerEvents === 'auto') {
                prevButton.click();
                yield new Promise((resolve) => setTimeout(resolve, 300));
                console.log('Moved to the previous page.');
            }
            console.log('Reached the first page.');
        });
    }
    static goToNextPage() {
        return __awaiter(this, void 0, void 0, function* () {
            const nextButton = document.querySelector('.next-button');
            if (nextButton && window.getComputedStyle(nextButton).pointerEvents === 'auto') {
                nextButton.click();
                yield new Promise((resolve) => setTimeout(resolve, 500));
                console.log('Moved to the next page.');
                return true;
            }
            console.warn('Next button not found or is disabled.');
            return false;
        });
    }
    captureCurrentPage() {
        return __awaiter(this, void 0, void 0, function* () {
            PDFExporter.setFixedSize(this.container, 820, 1180);
            const canvas = yield (0, html2canvas_1.default)(this.container, {
                scale: 2,
                useCORS: true,
                onclone: (clonedDoc) => {
                    clonedDoc.querySelectorAll('img').forEach((img) => {
                        if (!img.complete) {
                            img.addEventListener('load', () => console.log('Image loaded'));
                        }
                    });
                },
            });
            const imgData = canvas.toDataURL('image/jpeg', 0.8);
            this.capturedPages.push(imgData);
            console.log('Captured current page.');
            PDFExporter.resetOriginalSize(this.container);
        });
    }
    export() {
        return __awaiter(this, void 0, void 0, function* () {
            // init()
            this.capturedPages = [];
            this.pdf = new jspdf_1.default({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4',
            });
            const fileName = PDFExporter.generateFileName();
            if (!fileName) {
                console.log('Cancelled by user.');
                return;
            }
            yield PDFExporter.moveToFirstPage();
            console.log('Starting from the first page...');
            do {
                yield this.captureCurrentPage();
            } while (yield PDFExporter.goToNextPage());
            const pdfWidth = this.pdf.internal.pageSize.getWidth();
            const pdfHeight = this.pdf.internal.pageSize.getHeight();
            const topMargin = 20;
            const bottomMargin = 10;
            const availableHeight = pdfHeight - topMargin - bottomMargin;
            this.capturedPages.forEach((imgData, index) => {
                const imgWidth = pdfWidth;
                const imgHeight = (availableHeight * imgWidth) / pdfWidth;
                const finalImgHeight = imgHeight > availableHeight ? availableHeight : imgHeight;
                const finalImgWidth = (pdfWidth * finalImgHeight) / imgHeight;
                if (index > 0)
                    this.pdf.addPage();
                this.pdf.addImage(imgData, 'JPEG', (pdfWidth - finalImgWidth) / 2, topMargin, finalImgWidth, finalImgHeight);
            });
            this.pdf.save(fileName);
            console.log('PDF exported successfully.');
        });
    }
}
exports.PDFExporter = PDFExporter;
PDFExporter.DEFAULT_SELECTOR = '.app-content'; // 设定默认选择器
